// @ts-nocheck
import { ErrorMessage as ErrorCode } from '../Codes';
import {
    SignupErrorCode,
    ErrorMessages,
    ClearErrorMessages,
    ClearInfoMessages,
    CreatePasswordValidationMessageHTML,
    CreateErrorMessageHTML,
} from './sign-up-errors';

const Validator = (() => {
    const doRequiredFieldValidation = (field) => {
        ClearErrorMessages(field.parentNode);
        field.classList.remove('error');

        if (!field.value) {
            field.classList.add('error');
            field.parentNode.appendChild(
                CreateErrorMessageHTML('Please enter your ' + field.labels[0].textContent.toLowerCase()),
            );
        }
    };

    const doAllRequiredFieldsValidation = () => {
        const requiredFields = Array.from(document.querySelectorAll('[required]'));

        requiredFields.forEach((field) => {
            doRequiredFieldValidation(field);
        });
    };

    const doCompanyNameValidation = () => {
        const companyField = document.querySelector('input[name=PracticeName]');
        const companyName = companyField.value;

        const isTooLong = companyName.length > 100;
        const isEmpty = companyName === '';
        const isInvalidLength = isEmpty || isTooLong;

        ClearErrorMessages(companyField.parentNode);
        companyField.classList.remove('error');

        if (isInvalidLength) companyField.classList.add('error');

        if (isTooLong)
            companyField.parentNode.appendChild(CreateErrorMessageHTML(ErrorMessages[ErrorCode.PracticeNameTooLong]));

        if (isEmpty)
            companyField.parentNode.appendChild(CreateErrorMessageHTML(ErrorMessages[ErrorCode.PracticeNameRequired]));
    };

    const doEmailValidation = () => {
        const emailField = document.querySelector('input[name=Email]');
        const email = emailField.value;

        const isLongEnough = email.length > 0;
        const isCorrectFormat = new RegExp(emailField.pattern).test(email);

        ClearErrorMessages(emailField.parentNode);
        emailField.classList.remove('error');

        if (!isLongEnough || !isCorrectFormat) {
            emailField.classList.add('error');
            emailField.parentNode.appendChild(CreateErrorMessageHTML(ErrorMessages[ErrorCode.InvalidEmailAddress]));
        }
    };

    const doPasswordValidation = () => {
        const passwordField = document.querySelector('input[name=Password]');
        const password = passwordField.value;
        const messageContainer = document.getElementById('PasswordErrors');

        const isLongEnough = password.length >= 8;
        const hasLowerAndUpperCase = /[a-z].*[A-Z]|[A-Z].*[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);

        passwordField.classList.remove('error');
        ClearErrorMessages(passwordField.parentNode);
        ClearInfoMessages(passwordField.parentNode);

        const hasError = !isLongEnough || !hasLowerAndUpperCase || !hasNumber;
        if (hasError) {
            passwordField.classList.add('error');

            messageContainer.appendChild(
                CreatePasswordValidationMessageHTML(!isLongEnough, ErrorMessages[SignupErrorCode.PasswordTooShort]),
            );
            messageContainer.appendChild(
                CreatePasswordValidationMessageHTML(
                    !hasLowerAndUpperCase,
                    ErrorMessages[SignupErrorCode.PasswordMissingUpperAndLowerCase],
                ),
            );
            messageContainer.appendChild(
                CreatePasswordValidationMessageHTML(!hasNumber, ErrorMessages[SignupErrorCode.PasswordMissingNumber]),
            );
        }
    };

    const doSubscriptionPlanvalidation = () => {
        const trialPlanCollection = document.querySelectorAll('input[name="subscription-plan"]');
        const trialPlans = trialPlanCollection ? Array.from(trialPlanCollection) : [];

        const planList = trialPlans[0].closest('.plan-list');
        const subscriptionPlanField = planList.parentNode;

        ClearErrorMessages(subscriptionPlanField);
        planList.classList.remove('error');

        const hasPlan = trialPlans.some((plan) => plan.checked == true);
        if (!hasPlan) {
            planList.classList.add('error');
            subscriptionPlanField.appendChild(CreateErrorMessageHTML(ErrorMessages[ErrorCode.InvalidTrialProfile]));
        }
    };

    const doAcceptTermsValidation = () => {
        const acceptTerms = document.querySelector('input[name="AcceptTerms"]');
        const acceptTermsField = acceptTerms.closest('.signup-form-field');

        ClearErrorMessages(acceptTermsField);
        acceptTerms.labels[0]?.classList.remove('error');

        if (!acceptTerms.checked) {
            acceptTermsField.classList.add('error');
            acceptTerms.labels[0]?.classList.add('error');
            acceptTermsField.appendChild(CreateErrorMessageHTML(ErrorMessages[ErrorCode.AcceptTerms]));
        }
    };

    const doAll = () => {
        doAllRequiredFieldsValidation();
        doCompanyNameValidation();
        doEmailValidation();
        doPasswordValidation();
        doSubscriptionPlanvalidation();
        doAcceptTermsValidation();
    };

    return {
        CheckRequiredField: doRequiredFieldValidation,
        CheckAllRequiredFields: doAllRequiredFieldsValidation,
        CheckCompanyName: doCompanyNameValidation,
        CheckEmail: doEmailValidation,
        CheckPassword: doPasswordValidation,
        CheckSubscriptionPlan: doSubscriptionPlanvalidation,
        CheckAcceptTerms: doAcceptTermsValidation,
        CheckAll: doAll,
    };
})();

export default Validator;
